<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header">
            <span>轮播图设置</span>
        </div>
        <el-row>
            <el-col :lg="16" :md="12" :sm="24">
<!--                <el-carousel :interval="5000" v-if="data.length > 0" arrow="always" height="200px" style="width: 400px">-->
<!--                    <el-carousel-item v-for="item in data"  :key="item.id">-->
<!--                        <el-image style="width: 100%;height: auto" :src="item.url" fit="cover">-->

<!--                        </el-image>-->
<!--                    </el-carousel-item>-->
<!--                </el-carousel>-->
                <el-button type="success" style="margin-bottom: 15px" plain @click="addBtn">+ 添加轮播图</el-button>

                <el-alert
                    title="排序为正序排列(序号小的在前面)"
                    type="warning"
                    style="margin-bottom: 20px"
                >
                </el-alert>

                <el-table border :data="data">
                    <el-table-column label="图片" width="225">
                        <template slot-scope="scope">
                            <el-image
                                style="width: 200px; height: 100px"
                                :src="scope.row.url"
                                :preview-src-list="list"
                                fit="contain">
                                <div slot="error" style="height: 100px;width: 200px;background:#efefef;display:flex;justify-content: center;align-items: center;font-size: 40px;color: #aaa;border-radius:10px;">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="绑定文章">
                        <template slot-scope="scope">
                            <span class="warning_text" v-if="!scope.row.aid">
                                无
                            </span>
                            <el-link v-else type="primary" @click="preview(scope.row.aid)">{{parseArt(scope.row.aid)}}</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序" prop="sort_num" sortable width="150">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.is_edit">
                                {{scope.row.sort_num}}
                            </span>
                            <el-input-number v-else v-model="scope.row.sort_num" controls-position="right" :min="0" :max="1000" size="mini" style="width: 100px;display:inline-block;"></el-input-number>
                            <el-link type="warning" :underline="false" @click="editSort(scope.row,scope.$index)" v-if="!scope.row.is_edit">修改</el-link>
                            <el-link type="success" :underline="false" @click="saveSort(scope.row,scope.$index)" v-else>保存</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="65">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="success" v-if="scope.row.is_show == 1" @click="setShow(scope.row,0)">正常</el-link>
                            <el-link :underline="false" type="warning" v-if="scope.row.is_show == 0" @click="setShow(scope.row,1)">禁用</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button plain size="mini" type="warning" @click="editBtn(scope.row,scope.$index)">编辑</el-button>
                            <el-button plain size="mini" type="danger" @click="del(scope.row,scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <el-dialog title="添加轮播图" :visible.sync="add_dialog" width="30%">
            <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px">
                <el-alert style="margin-bottom: 10px" type="warning" title="为了好的显示效果,请尽量上传宽高比一致的图片,推荐上传图片宽高比为 2:1"></el-alert>
                <el-form-item label="图片" prop="url">
                    <el-image
                        style="width: 200px; height: 100px"
                        :src="addForm.url"
                        fit="contain">
                        <div slot="error" style="height: 100px;width: 200px;background:#efefef;display:flex;justify-content: center;align-items: center;font-size: 40px;color: #aaa;border-radius:10px;">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div>
                        <el-button size="mini" plain type="primary" @click="click_file('addFile')" :loading="is_upload">更新图片</el-button>
                        <span style="font-size: 12px;color: #aaa">
                            只能上传jpg,jpeg,png,gif的图片,最大不超过1MB
                        </span>
                        <input type="file" name="addFile" @change="file_change($event,'add')" ref="addFile" style="display:none;">
                    </div>
                </el-form-item>
                <el-form-item label="关联文章">
                    <el-select v-model="addForm.aid" clearable placeholder="请选择一篇文章">
                        <el-option
                            v-for="item in artList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="primary" @click="addSubmit" :loading="is_post">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog title="修改轮播图" :visible.sync="edit_dialog" width="30%">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px">
                <el-alert style="margin-bottom: 10px" type="warning" title="为了好的显示效果,请尽量上传宽高比一致的图片,推荐上传图片宽高比为 2:1"></el-alert>
                <el-form-item label="图片" prop="url">
                    <el-image
                        style="width: 200px; height: 100px"
                        :src="editForm.url"
                        fit="contain">
                        <div slot="error" style="height: 100px;width: 200px;background:#efefef;display:flex;justify-content: center;align-items: center;font-size: 40px;color: #aaa;border-radius:10px;">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <div>
                        <el-button size="mini" plain type="primary" @click="click_file('editFile')" :loading="is_upload">更新图片</el-button>
                        <span style="font-size: 12px;color: #aaa">
                            只能上传jpg,jpeg,png,gif的图片,最大不超过1MB
                        </span>
                        <input type="file" name="editFile" ref="editFile" @change="file_change($event,'edit')" style="display:none;">
                    </div>
                </el-form-item>
                <el-form-item label="关联文章">
                    <el-select v-model="editForm.aid" clearable placeholder="请选择一篇文章">
                        <el-option
                            v-for="item in artList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button plain type="warning" @click="editSubmit" :loading="is_post">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="文章预览" width="454px" top="20px" :visible.sync="preview_dialog">
            <iframe :srcdoc="preview_html" loading="lazy" frameborder="0" scrolling="auto" height="736" width="414" style="overflow-y: auto"></iframe>
        </el-dialog>

    </el-card>
</template>

<script>
import NodeRequest from "@/utils/node-request"

export default {
    name: 'img_map',
    data(){
        return {
            is_ok:false,
            is_post:false,
            is_upload:false,
            add_dialog:false,
            edit_dialog:false,
            data:[],
            preview_html:"",
            preview_dialog:false,
            rules:{
                url:[
                    { required: true, message: '请上传一张图片', trigger: 'blur' },
                ]
            },
            addForm:{
                url:"",
                aid:""
            },
            editForm:{
                id:0,
                url:"",
                aid:""
            },
            list:[],
            artList:[]
        }
    },
    methods:{
        addBtn(){
            this.add_dialog = true;
        },
        getData(){
            this.is_ok = false;
            NodeRequest.get("imap/index").then(res=>{
                this.is_ok = true;
                res.data.map((item)=>{
                    item.is_edit = false;
                });
                this.data = res.data;
                this.flushList();
            }).catch(err=>{
                this.is_ok = true;
            });
        },
        setShow(item,is_show){
            this.is_post = true;
            NodeRequest.post("imap/set_show",{id:item.id,is_show:is_show}).then(res=>{
                this.is_post = false;
                item.is_show = is_show;
                this.$message.success("操作成功");
            }).catch(err=>{
                this.is_post = false;
            });
        },
        addSubmit(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                NodeRequest.post("imap/create",this.addForm).then(res=>{
                    this.data.push(res.data);
                    this.is_post = false;
                    this.add_dialog = false;
                    this.$refs["addForm"].resetFields();
                    this.addForm = {
                        url:"",
                        aid:""
                    };
                    this.flushList();
                    this.$message.success("添加轮播图成功!");
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editBtn(item,i){
            this.editForm.id = item.id;
            this.editForm.url = item.url;
            this.editForm.aid = item.aid == 0?'':item.aid;
            this.edit_dialog = true;
        },
        editSubmit(){
            this.$refs["editForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                NodeRequest.post("imap/edit",this.editForm).then(res=>{
                    this.is_post = false;
                    for(let i =0;i<this.data.length;i++) {
                        if (this.data[i].id == this.editForm.id) {
                            this.data[i].url = res.data.url;
                            this.data[i].aid = res.data.aid;
                        }
                    }
                    this.$message.success("修改轮播图成功");
                    this.edit_dialog = false;
                    this.flushList();
                }).catch(err=>{
                    this.is_post = false;
                });
            })
        },
        click_file(type){
            this.$refs[type].click();
        },
        file_change(e,type){
            let file = e.target.files[0];
            this.is_upload = true;
            this.$store.dispatch("upload/uploadImg",{file:file}).then(res=>{
                e.target.value = "";
                this.is_upload = false;
                if(type == "add"){
                    this.addForm.url = res.url;
                }else{
                    this.editForm.url = res.url;
                }
                this.$message.success("上传图片成功!");
                this.is_upload = false;
            }).catch(err=>{
                this.is_upload = false;
                e.target.value = "";
                this.$message.warning(err.msg);
            });
        },
        flushList(){
            this.list = [];
            for(let item of this.data){
                this.list.push(item.url);
            }
        },
        parseArt(aid){
            let res = "";
            for(let item of this.artList){
                if(item.id == aid){
                    res = item.name;
                    break;
                }
            }
            return res;
        },
        del(item,i){
            this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.is_post = true;
                NodeRequest.post("imap/del",{id:item.id}).then(res=>{
                    for(let i =0;i<this.data.length;i++){
                        if(this.data[i].id == item.id){
                            this.data.splice(i,1)
                        }
                    }
                    this.flushList();
                    this.$message.success("删除操作成功");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        editSort(item,i){
            item.is_edit = !item.is_edit;
        },
        saveSort(item,i){
            if(!item.sort_num){
                item.sort_num = 0;
            }else if(isNaN(item.sort_num)){
                this.$message.warning("参数错误!");
                return false;
            }
            this.is_post = true;
            NodeRequest.post("imap/set_sort",{id:item.id,sort_num:item.sort_num}).then(res=>{
                item.is_edit = !item.is_edit;
                this.is_post = false;
                this.$message.success("修改成功!");
            }).catch(err=>{
                this.is_post = false;
            });
        },
        getArt(){
            return new Promise((resolve,reject)=>{
                NodeRequest.post("article/index").then(res=>{
                    this.artList = res.data;
                    resolve(res.data);
                }).catch(err=>{
                    reject(err);
                });
            });
        },
        preview(aid){
            for(let item of this.artList){
                if(item.id == aid){
                    this.preview_html = item.content;
                    this.preview_dialog = true;
                    break;
                }
            }
        }
    },
    created() {
        this.getArt().then((list)=>{
            this.getData();
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
.image-slot{
    width: 100%;
    height: 100%;
}
</style>
